import { createSelector } from 'reselect';

export const selectApi = (state) => state.api;

export const selectAbortableRequests = createSelector(selectApi, (api) => api.abortableRequests);

export const apiSelectors = {
  selectAbortableRequests,
};
